module.exports = __webpack_public_path__ + "img/gzh.271791cd.jpg";